import { Component, EventEmitter, HostListener, Input, OnChanges, Output } from "@angular/core";
import { DateService } from "@app/services/date.service";
import './video-controls.component.scss';

@Component({
    selector: 'v-video-controls',
    template: require('./video-controls.component.html')
})
export class VVideoControlsComponent implements OnChanges {

    @Input() secondsPlayed: number;
    @Input() videoDuration: number;
    @Input() isPlaying: boolean;
    @Input() isTimedOut: boolean;
    @Input() liveStream: boolean;
    @Input() hideSkipControls = false;

    @Output() play = new EventEmitter<MouseEvent>();
    @Output() pause = new EventEmitter<MouseEvent>();
    @Output() rewind = new EventEmitter<void>();
    @Output() fastForward = new EventEmitter<void>();
    @Output() close = new EventEmitter<MouseEvent>();
    @Output() restart = new EventEmitter<MouseEvent>();
    @Output() fullscreen = new EventEmitter<MouseEvent>();
    @Output() fitToFrame = new EventEmitter<{ fit: boolean, event: MouseEvent }>();
    @Output() zoom = new EventEmitter<{ zoomIn: boolean, event: MouseEvent }>();
    @Output() speedChanged = new EventEmitter<number>();

    isFullScreen: boolean;
    fillFrame: boolean;
    isZoomed: boolean;
    secondsPlayedString: string;
    videoDurationString: string;

    showPlaybackSpeedOptions: boolean;
    playbackSpeed: number = 1;
    playbackSpeedOptions: number[] = [2, 1.5, 1, 0.5, 0.25];

    showZoom = true;
    showFitToFrame = true;
    showSpeedOptions = true;
    showFwRw = true;
    showRestart = true;

    constructor(
        private readonly dateService: DateService
    ) { }

    ngOnChanges(): void {
        this.updateTime();
        this.checkButtonVisibility();
    }

    @HostListener("click", ["$event"]) onClick(event: MouseEvent): void {
        event.stopPropagation();
    }

    togglePlayPause(event: MouseEvent): void {
        if (!this.isPlaying) {
            this.play.emit(event)
        }
        else {
            this.pause.emit(event);
        }

        this.isPlaying = !this.isPlaying;
    }

    restartAll(event: MouseEvent): void {
        this.isPlaying = true;
        this.restart.emit(event);
    }

    toggleFullScreen(event: MouseEvent): void {
        this.isFullScreen = !this.isFullScreen;
        this.fullscreen.emit(event);
    }

    toggleFitToFrame(event: MouseEvent): void {
        this.fillFrame = !this.fillFrame;
        this.fitToFrame.emit({ fit: this.fillFrame, event: event });
    }

    toggleZoom(event: MouseEvent): void {
        this.isZoomed = !this.isZoomed;
        this.zoom.emit({ zoomIn: this.isZoomed, event: event });
    }

    closeAll(event: MouseEvent): void {
        this.close.emit(event);
    }

    setPlaybackSpeed(event: MouseEvent, speedOption: number): void {
        this.playbackSpeed = speedOption;
        this.togglePlaybackSpeedOptions(false);
        this.speedChanged.emit(speedOption)
    }

    togglePlaybackSpeedOptions(show = false): void {
        this.showPlaybackSpeedOptions = show;
    }

    fastForwardClick(): void {
        this.fastForward.emit();
    }

    rewindClick(): void {
        this.rewind.emit();
    }

    // ---

    private updateTime(): void {

        // Current time
        let rounded = Math.floor(this.secondsPlayed);
        this.secondsPlayedString = this.dateService.formatTimeDuration(rounded);

        rounded = Math.floor(this.videoDuration);
        this.videoDurationString = this.dateService.formatTimeDuration(rounded);

        this.secondsPlayedString = this.secondsPlayedString || "00:00";
        this.videoDurationString = this.videoDurationString || "00:00";
    }

    private checkButtonVisibility(): void {
        this.showFitToFrame = !!this.fitToFrame.observers.length;
        this.showSpeedOptions = !!this.speedChanged.observers.length;
        this.showZoom = !!this.zoom.observers.length;
        this.showFwRw = !!this.rewind.observers.length && !!this.fastForward.observers.length && !this.liveStream && !this.hideSkipControls;
        this.showRestart = !!this.restart.observers.length && !this.liveStream;
    }
}
